export enum CurrentType {
    ADD,
    EDIT
}